export enum SmarticoProfileEvent {
  UpdateProfile = 'update_profile',
}
